export const parseWipScanCode = (rawValue) => {
  const raw = String(rawValue || '').trim();
  if (!raw) return null;

  const values = {};
  raw.split('|').forEach((part) => {
    const separator = part.indexOf('=');
    if (separator < 1) return;
    values[part.slice(0, separator).trim().toUpperCase()] = part.slice(separator + 1).trim();
  });

  if (!values.ID && !values.MAT) return null;
  return {
    raw,
    id: values.ID || '',
    matCode: values.MAT || '',
    lot: values.LOT || '',
    batch: values.BATCH || '',
    shift: values.SHIFT || '',
  };
};

const same = (left, right) => String(left ?? '').trim().toUpperCase() === String(right ?? '').trim().toUpperCase();

export const findRegistrationForScan = (registrations, parsed, location) => {
  if (!parsed) return null;
  if (parsed.id) {
    return registrations.find((item) => String(item.id) === String(parsed.id)) || null;
  }

  const matches = registrations.filter((item) => (
    same(item.mat_code, parsed.matCode)
    && same(item.lot, parsed.lot)
    && same(item.batch, parsed.batch)
    && same(item.shift, parsed.shift)
  ));
  return matches.find((item) => same(item.location, location)) || matches[0] || null;
};

export const mobileScanStatusCounts = (items = []) => items.reduce((result, item) => {
  const key = String(item.status || '').trim().toUpperCase().replace(/[ -]+/g, '_');
  result.total += 1;
  if (key === 'READY') result.ready += 1;
  else if (key === 'MUST_USE') result.mustUse += 1;
  else if (key === 'EXPIRED') result.expired += 1;
  else if (key === 'PREPARING') result.preparing += 1;
  return result;
}, { total: 0, ready: 0, mustUse: 0, expired: 0, preparing: 0 });

export const apiErrorMessage = (error, fallback = 'ไม่สามารถดำเนินการได้') => {
  const data = error?.response?.data;
  if (typeof data === 'string' && data.trim()) return data;
  if (typeof data?.detail === 'string') return data.detail;
  if (data && typeof data === 'object') {
    const first = Object.values(data).flat()[0];
    if (first) return String(first);
  }
  return error?.message || fallback;
};
